module.exports = __webpack_public_path__ + "e304cc929cd1168398d7fe0275915f53.png";